// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "cdd3405a26f768994109" + ".bundle.js";
};